import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AddressProviderEffects } from './address-provider.effects';
import { addressProviderReducer } from './address-provider.reducer';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature('addressProvider', addressProviderReducer), EffectsModule.forFeature([AddressProviderEffects])],
})
export class AddressProviderStateModule {}
